import React from 'react'
import { config } from 'config'
import Helmet from 'react-helmet'
import LazyLoad from 'react-lazyload'

import PageNav from './PageNav'
import Image from './Image'

import '../css/single.css'

const Component = React.createClass({
  getInitialState: function() {
    return {
      loaded: false,
      vw: 960
    }
  },
  onImageLoad: function() {
    if (this.isMounted()) {
      this.setState({ loaded: true });
    }
  },
  getElementContentWidth: function(element) {
    var styles = window.getComputedStyle(element);
    var padding = parseFloat(styles.paddingLeft) +
                  parseFloat(styles.paddingRight);

    return element.clientWidth - padding;
  },
  updateDimensions: function() {
    const vw = this.getElementContentWidth(document.getElementById('container'))
    this.setState({ vw })
  },
  componentDidMount: function() {
    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions);
  },
  componentWillUnmount: function() {
      window.removeEventListener("resize", this.updateDimensions);
  },
  render: function() {
    const article = this.props.content.map(element => {
      const vSize = this.state.vw >= 800 ? 'large' : this.state.vw >= 500 ? 'medium' : 'small'
      const largeImageWidth = vSize === 'large' ? 0.7 : 1
      const smallImageWidth = vSize === 'large' ? 0.55 : vSize === 'medium' ? 0.8 : 1
      const imgStyle = {
        maxWidth: '100%',
      }

      const videoWidth = this.state.vw
      const videoHeight = this.state.vw / 1920 * 1080

      const smallImageStyle = {
        first: imgStyle,
        second: {
          ...imgStyle,
          marginTop: vSize !== 'small' ? '-80px' : '',
          marginRight: element.position === 'right' && vSize === 'large' ? '15%' : '' ,
          marginLeft: element.position === 'left' && vSize === 'large' ? '15%' : '',
          alignSelf: vSize !== 'medium' ? '' : element.position === 'right' ? 'flex-start' : 'flex-end'
        }
      }

      const smallPStyle = {
        alignSelf: element.position === 'right' ? 'flex-start' : 'flex-end',
        width: vSize === 'large' ? '35%' : '100%',
        marginBottom: vSize === 'large' ? '-10%' : ''
      }

      switch (element.type) {
        case 'video':
          return (<div>
            <iframe style={{border: 0}} src={`https://player.vimeo.com/video/${element.videoId}?autoplay=0&title=0&color=ffa500&byline=0&portrait=0`} width={videoWidth} height={videoHeight} frameBorder="0" allowFullScreen></iframe>

          </div>)
          break
        case 'text':
          return (<p
              style={{
                // fontSize: '1.2rem'
              }}
            >{element.text}</p>)
          break
        case 'heading':
          return (<p
              style={{
                fontSize: '1.3rem',
                fontFamily: 'Oswald, sans-serif',
                marginBottom: '3rem'
              }}
            >{element.text}</p>)
          break
        case 'img-full':
          return (
            <Image maxWidth={this.state.vw} width={largeImageWidth} style={{
            maxWidth: '100%',
            alignSelf: element.position === 'right' ? 'flex-end' : 'flex-start'
            }} imgId={element.imgId} alt={element.alt} aspectRatio={element.aspectRatio}/>
          )
          break
        case 'group':
          const style = {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            marginTop: vSize === 'large' ? '5rem' : ''
          }

          return (<div style={{...style,
            alignItems: element.position === 'left' ? 'flex-start' : 'flex-end'}}>
            <p style={smallPStyle}>{element.text}</p>
          <Image maxWidth={this.state.vw} width={smallImageWidth} style={smallImageStyle.first} imgId={element.firstImg.id} alt={element.firstImg.alt} aspectRatio={element.firstImg.aspectRatio}/>
            <Image maxWidth={this.state.vw} width={smallImageWidth} style={smallImageStyle.second} imgId={element.secondImg.id} alt={element.secondImg.alt} aspectRatio={element.secondImg.aspectRatio}/>
          </div>)
      }
    })
    return (<div>
      <Helmet
        title={`${config.siteTitle} | ${this.props.name}`}
      />
      <article
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%'
        }}
      >

        {article}
        <PageNav color={this.props.color} next={this.props.next} previous={this.props.previous}/>
      </article>
    </div>)
  }
})

export default Component



// WEBPACK FOOTER //
// ../components/Person.js